import PostBody from "../components/post-body";
import CallToActionSmall from "../components/v2/call-to-action-sm";
import "../styles/scss/content.module.scss";
import '../styles/scss/_trusted-companies.module.scss';



export default function CommonPageTemplate({ pageData }) {
    let page = pageData?.pages?.edges?.[0]?.node

  return (
      <>

          { page?.content ? <PostBody content={page?.content} />  : <div className={'container'}><div className={'coming-soon'}><h1>{page?.title} Coming soon</h1></div></div>}
          <CallToActionSmall/>
      </>
  )
}



